<template>
    <div class="merchants ">
        <img :src="bannerPath"
             @click="jump()"
             v-if="bannerPath!=''" />
        <!-- <div class="way">
            <el-row type="flex"
                    class="row-bg"
                    justify="center">
                <el-col :span="20">
                    <breadcrumb></breadcrumb>
                </el-col>
            </el-row>
        </div> -->
        <div class="main">
            <el-row type="flex"
                    class="row-bg equipart"
                    justify="center">
                <el-col :span="20"
                        class="equipartition">
                    <div class="btn"
                         v-for="(item,index) in brotherMenu"
                         :key="index"
                         @click="assign(item)"
                         :class="{active: activeIndex === item.id}">
                        <p class="line">{{item.name}}</p>
                    </div>
                </el-col>
            </el-row>
        </div>
        <keep-alive>
            <component :is="currentpage"></component>
        </keep-alive>
    </div>
</template>

<script>
import { queryproductbanner } from "@/api/productInfo";
import { mapGetters } from "vuex";
import breadcrumb from "@/components/breadcrumb";
// import Bus from "@/utils/bus";
import franchise from "@/views/merchants/franchise";
import region from "@/views/merchants/region";
import alliance from "@/views/merchants/alliance";
import problem from "@/views/merchants/problem";
import documentation from "@/views/merchants/documentation";
export default {
    components: {
        franchise,
        region,
        alliance,
        problem,
        documentation,
        breadcrumb
    },

    data() {
        return {
            // activeIndex: "",
            bannerHeight: "400",
            imaUrl: "@/assets/images/banner1.png",
            position: "",

            currentpage: "franchise",
            list: [
                { name: "franchise", title: "加盟介绍" },
                { name: "region", title: "开放区域" },
                { name: "alliance", title: "加盟申请" },
                { name: "problem", title: "常见问题" },
                { name: "documentation", title: "成功案例" }
            ]
        };
    },
    watch: {
        //监听路由变化
        $route(to, from) {
            this.currentpage = this.$route.params.id;
            // this.search();
        }
    },
    computed: {
        ...mapGetters([
            "activeIndex",
            "parentList",
            "bannerPath",
            "brotherMenu"
        ])
    },
    created() {
        // this.search();
        this.currentpage = this.$route.params.id;
        // this.currentpage = this.$route.params.id;
    },
    mounted() {
        if (sessionStorage.getItem("activeIndex")) {
            this.$store.dispatch(
                "BannerPath",
                sessionStorage.getItem("activeIndex")
            );
        }
    },
    methods: {
        jump() {
            queryproductbanner(this.activeIndex).then(res => {
                if (res.status === 2000) {
                    if (res.data.demoFlag) {
                        this.$store.dispatch("UpdateActive", res.data);
                    }
                }
            });
        },

        assign(item) {
            this.$router.push({
                path: item.demoFlag,
                query: {
                    id: item.id
                }
            });
            this.$store.dispatch("BannerPath", item.id);
            // this.$store.dispatch("UpdateActive", item);
            this.$store.dispatch("ContentDesc", item.id);
        }
    }
};
</script>

<style scoped lang="scss">
.merchants {
    .banner {
        width: 100%;
        height: 100%;
    }
    img {
        width: 100%;
        // max-height: 400px;
    }
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #221814;
        .el-breadcrumb {
            line-height: 50px;
        }
    }
    .main {
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        .equipart {
            .equipartition {
                display: flex;
                .btn {
                    flex: 1;
                    cursor: pointer;
                    height: 54px;
                    margin: 0 auto;
                    display: inline-block;
                    text-align: center;
                    font-size: 20px;
                    line-height: 54px;
                }
            }
        }
    }
    .active {
        border-bottom: 2px solid #fabe00;
    }
}
</style>
